import { Component, ViewChild } from '@angular/core';
import { DisplayState, SignUpFacade, SignUpState } from './sign-up.facade';
import { ConsentDialogComponent } from './consent-dialog/consent-dialog.component';
import { ConsentData } from '../../global-components/global-consent-form/global-consent-form.component';
import { Subscription } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { FormBuilder } from '@angular/forms';
import { GlobalLangChooserComponent } from '../../global-components/global-lang-chooser/global-lang-chooser.component';
import { DropdownModule } from "primeng/dropdown";
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

export const TITLES = [
  "Mr",
  "Mrs",
  "Miss",
  "Dr"
];

@Component({
  selector: 'app-sign-up',
  imports: [
    ...COMMON_IMPORTS,
    ConsentDialogComponent,
    DialogModule,
    GlobalLangChooserComponent,
    DropdownModule,
  ],
  templateUrl: './sign-up.component.html',
  styleUrl: "./sign-up.component.css"
})
export class SignUpComponent {
  @ViewChild(ConsentDialogComponent) consentDialog!: ConsentDialogComponent;
  passwordVisible = false;
  confirmPasswordVisible = false;
  showConsentDialog = false;
  showContact = false;
  showContactDialog = false;
  state: SignUpState = DisplayState.blankDisplayState();


  public readonly titles = TITLES;

  private sub = new Subscription();

  private dialogConfirmed: boolean = false;

  constructor(
    private fb: FormBuilder,
    private facade: SignUpFacade,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.sub.add(
      this.facade.state$.subscribe((state) => {
        this.state = state;
      })
    );

    //Extract query params and url decode
    const urlParams = new URLSearchParams(window.location.search);
    let emailParam = urlParams.get('email');
    let inviteToken: string | null = urlParams.get("inviteToken");

    if (emailParam) {
      emailParam = decodeURIComponent(emailParam);
    }
    if (inviteToken) {
      inviteToken = decodeURIComponent(inviteToken);
    }

    this.facade.begin(emailParam, inviteToken ?? undefined);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  toggleConfirmPasswordVisibility() {
    this.confirmPasswordVisible = !this.confirmPasswordVisible;
  }

  onSignUp() {
    this.state.form.setErrors(null);

    if (this.state.form.invalid) {
      this.state.form.markAllAsTouched();
      console.log(this.state.form.errors, this.state.form);

      return;
    }

    this.showConsentDialog = true;
  }

  onConsentResult(data: ConsentData) {
    this.showConsentDialog = false;
    if (this.consentDialog.accepted) {
      this.facade.signUpPressed(data);
    }
  }

  get signUpForm() {
    return this.state.form;
  }
}
